import { Grid, makeStyles, Typography } from "@material-ui/core";
import SucessoFestivoIcon from "shared/components/icons/SucessoFestivoIcon";
import gifFesta from "static/cloud21/gifs/gif-festa.gif";
import stylesAtivacaoConcluida from "./styles/TelaAtivacaoConcluidaGroupPayStyles";

const TelaAtivacaoConcluidaGroupPay: React.FC = () => {
  const styles = stylesAtivacaoConcluida();

  const SessaoPrincipal = () => {
    return (
      <Grid item xs={12} className={styles.containerImagem}>
        <img src={gifFesta} alt="festa" className={styles.imagem} />
          <div className={styles.icone}>
            <SucessoFestivoIcon />
            <span className={styles.textoConclusao}>
              {`Em breve, um dos `}
              <span className={styles.nossoConsultor}>
                nossos consultores entrará em contato
              </span>
            </span>
            <Typography variant="body1" style={{ marginTop: "1rem", textAlign: "center" }}>
              Daremos sequência ao processo para iniciar uma nova fase na sua gestão com o Group Pay.
            </Typography>
          </div>
      </Grid>
    )
  };

  const SessaoAtendimento = () => {
    return (
      <Grid item xs={12} className={styles.containerAtendimento}>
        <div className={styles.textoAtendimento}>
          <Typography variant="subtitle1">
            💬 Quer agilizar o atendimento?            
          </Typography>
          <span>
            <Typography variant="body1">
              Adiante os próximos passos falando com a
              <a href="https://wa.me/5531983706243" className={styles.linkEntreEmContato} target="_blank"> nossa equipe por aqui.</a>
            </Typography>
          </span>
        </div>
      </Grid>
    )
  };

  return (
    <Grid container>
      <SessaoPrincipal/>
      <SessaoAtendimento/>
    </Grid>
  );
};

export default TelaAtivacaoConcluidaGroupPay;
